import { Box, SvgIcon } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Icons from '@Constants/Icons.constants';

import { PaginationIconButton } from './TablePaginationActions.styles';
import TablePaginationActionsProps from './TablePaginationActions.types';

/**
 * Custom Pagination Actions
 */
const TablePaginationActions = (
  props: TablePaginationActionsProps
): JSX.Element => {
  const { count, page, rowsPerPage, onPageChange } = props;
  const theme = useTheme();

  /** Handles First Page Button Click. */
  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, 0);
  };

  /** Handles Back Button Click. */
  const handleBackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page - 1);
  };

  /** Handles Next Button Click. */
  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page + 1);
  };

  /** Handles Last Page Button Click. */
  const handleLastPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.4 }}>
      <PaginationIconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? (
          <SvgIcon>{Icons.lastPage}</SvgIcon>
        ) : (
          <SvgIcon>{Icons.firstPage}</SvgIcon>
        )}
      </PaginationIconButton>
      <PaginationIconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? (
          <SvgIcon>{Icons.keyboardArrowRight}</SvgIcon>
        ) : (
          <SvgIcon>{Icons.keyboardArrowLeft}</SvgIcon>
        )}
      </PaginationIconButton>
      <PaginationIconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? (
          <SvgIcon>{Icons.keyboardArrowLeft}</SvgIcon>
        ) : (
          <SvgIcon>{Icons.keyboardArrowRight}</SvgIcon>
        )}
      </PaginationIconButton>
      <PaginationIconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? (
          <SvgIcon>{Icons.firstPage}</SvgIcon>
        ) : (
          <SvgIcon>{Icons.lastPage}</SvgIcon>
        )}
      </PaginationIconButton>
    </Box>
  );
};

export default TablePaginationActions;
